module.exports = __webpack_public_path__ + "img/icon-hallazgos-umesr.23f9495d.svg";